export type TranslationKey = `${string}.${string}` | string;

export type TFunction = (key: TranslationKey, fallback: string) => string;

export const t: TFunction = (_key, fallback) => fallback;

export function useTranslation(): { t: TFunction } {
  return { t };
}
